import React from "react";
import classNames from "classnames";

export default class LoadingPanel extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = false;
    this.timer = null;
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.timeout = true;
      this.forceUpdate();
    }, 5000);
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  render() {
    let loadingClass = classNames({
      loading: true,
      hidden: !this.props.show,
      "no-menu": this.props.noMenu,
    });

    let source = this.timeout
      ? "/static/images/loading_dead.svg"
      : "/static/images/loading.svg";
    let alt = this.timeout ? "dead loading" : "loading...";

    return (
      <div className={loadingClass}>
        <img src={source} alt={alt} />
      </div>
    );
  }
}
